<template>
  <v-form ref="form" v-model="valid" lazy-validation>
    <v-row>
      <v-col :md="6" cols="12" class="py-0">
        <v-row no-gutters>
          <v-col :md="3" cols="12">
            <label class="titleForm titleForm-center">
              <v-icon
                class="fab fa-facebook-f"
                size="18"
                color="#2F80ED"
              ></v-icon>
              <translate>Facebook</translate>
            </label>
          </v-col>
          <v-col :md="8" cols="12">
            <v-text-field
              class="field-custom"
              v-model="formData.facebookUrl"
              outlined
              :rules="urlRules"
            ></v-text-field>
          </v-col>
        </v-row>
      </v-col>

      <v-col :md="6" cols="12" class="py-0">
        <v-row no-gutters>
          <v-col :md="3" cols="12">
            <label class="titleForm titleForm-center">
              <v-icon
                class="fab fa-instagram"
                size="21"
                color="#E02AB8"
              ></v-icon>
              <translate>Instagram</translate>
            </label>
          </v-col>
          <v-col :md="8" cols="12">
            <v-text-field
              class="field-custom"
              v-model="formData.instagramUrl"
              outlined
              :rules="urlRules"
            ></v-text-field>
          </v-col>
        </v-row>
      </v-col>

      <v-col :md="6" cols="12" class="py-0">
        <v-row no-gutters>
          <v-col :md="3" cols="12">
            <label class="titleForm titleForm-center">
              <v-icon class="fab fa-twitter" size="21" color="#56CCF2"></v-icon>
              <translate>Twitter</translate>
            </label>
          </v-col>
          <v-col :md="8" cols="12">
            <v-text-field
              class="field-custom"
              v-model="formData.twitterUrl"
              outlined
              :rules="urlRules"
            ></v-text-field>
          </v-col>
        </v-row>
      </v-col>

      <v-col :md="6" cols="12" class="py-0">
        <v-row no-gutters>
          <v-col :md="3" cols="12">
            <label class="titleForm titleForm-center">
              <v-icon class="fab fa-youtube" size="21" color="#EB5757"></v-icon>
              <translate>Youtube</translate>
            </label>
          </v-col>
          <v-col :md="8" cols="12">
            <v-text-field
              class="field-custom"
              v-model="formData.youtubeUrl"
              outlined
              :rules="urlRules"
            ></v-text-field>
          </v-col>
        </v-row>
      </v-col>

      <v-col cols="12" class="mb-4" v-if="!hideSubmit">
        <v-btn
          large
          @click="$emit('cancel')"
          class="font-weight-bold elevation-0 text-none subtitle-1 mr-3"
        >
          <translate>Cancel</translate>
        </v-btn>
        <v-btn
          large
          type="submit"
          color="primary"
          @click.prevent="onSubmit"
          class="font-weight-bold elevation-0 text-none subtitle-1"
        >
          <translate>Save</translate>
        </v-btn>
      </v-col>
    </v-row>
  </v-form>
</template>
<script>
export default {
  props: [
    "facebookUrl",
    "instagramUrl",
    "twitterUrl",
    "youtubeUrl",
    "hideSubmit",
  ],
  data() {
    return {
      valid: true,
      urlRules: [(v) => this.isURL(v) || "URL is not valid"],
    };
  },
  computed: {
    formData() {
      let data = {
        facebookUrl: this.facebookUrl || "",
        instagramUrl: this.instagramUrl || "",
        twitterUrl: this.twitterUrl || "",
        youtubeUrl: this.youtubeUrl || "",
      };
      return data;
    },
  },
  methods: {
    onSubmit() {
      if (this.$refs.form.validate()) {
        this.$emit("submit", { type: "socials", data: this.formData });
        return true;
      } else {
        return false;
      }
    },
    isURL(str) {
      let url;
      if (str === "") return true;
      try {
        url = new URL(str);
      } catch (_) {
        return false;
      }
      return url.protocol === "http:" || url.protocol === "https:";
    },
  },
};
</script>
<style lang="scss">
.titleForm-center {
  vertical-align: middle;
  line-height: 41px !important;
  i {
    margin-right: 10px;
    margin-top: -3px;
  }
}
</style>